import React from 'react'
import { observer } from 'mobx-react'
import JobViewModel from '../JobViewModel'
import { Card, CardContent } from 'components/Card'
import { IconButton } from 'components/IconButton'
import Icon from 'components/Icon'
import Milestones from './Milestones'
import styles from './MilestonesCard.sass'
import MilestoneSwitcher from './Milestones/MilestoneSwitcher'

interface Props {
  vm: JobViewModel
}
export default observer(function MilestonesCard({ vm }: Props) {
  const isOpen = vm.milestonesVM.showingMilestoneSwitcher

  return (
    <Card dataTest="milestones-new">
      <CardContent scroll compact>
        <div className={styles.root}>
          <ImageProgress
            progress={vm.milestonesVM.taskCompletionProgress}
            illustration={
              <img
                src={require('assets/images/img_milestone_progress.svg')}
                alt=""
              />
            }
          />
          <h3 className={styles.title}>
            <span data-test="job-milestone-title-new">
              {vm.milestonesVM.milestone?.title}
            </span>
            <div className={styles.milestoneSwitcherButton}>
              <IconButton
                onClick={() =>
                  vm.milestonesVM.showingMilestoneSwitcher
                    ? vm.milestonesVM.closeMilestoneSwitcher()
                    : vm.milestonesVM.showMilestoneSwitcher()
                }
                data-test="milestone-switcher-button-new"
              >
                <Icon name="arrow" rotate={isOpen ? -90 : 90} />
              </IconButton>
            </div>
            <MilestoneSwitcher vm={vm.milestonesVM} isCardLayout />
          </h3>
          <h4
            className={styles.milestonesCompleted}
            data-test={`milestones-completion-progress-${vm.milestonesVM.milestone?.id}-new`}
          >
            {vm.milestonesVM.completedTasksCount} of{' '}
            {vm.milestonesVM.tasksCount} milestones completed
            <span className={styles.divider}>|</span>
            {vm.milestonesVM.taskCompletionProgress}% completed
          </h4>
          <div className={styles.tasks}>
            <Milestones vm={vm.milestonesVM} isCardLayout />
          </div>
        </div>
      </CardContent>
    </Card>
  )
})

interface ImageProgressProps {
  progress: number
  illustration?: React.ReactNode
}

const ImageProgress = ({ progress, illustration }: ImageProgressProps) => {
  return (
    <div className={styles.progressContainer}>
      <div
        className={styles.progress}
        style={{ transform: `scale(1, ${progress / 100})` }}
      />
      <div className={styles.progressIllustration}>{illustration}</div>
    </div>
  )
}
